import { render, staticRenderFns } from "./MasterTopBar.vue?vue&type=template&id=536ff24b&scoped=true"
import script from "./MasterTopBar.vue?vue&type=script&lang=js"
export * from "./MasterTopBar.vue?vue&type=script&lang=js"
import style0 from "./MasterTopBar.vue?vue&type=style&index=0&id=536ff24b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536ff24b",
  null
  
)

export default component.exports